
// ----- Static messages -----
const IS_PRODUCT_TEMPLATE = document.body.classList.contains("template-product");

const message = IS_PRODUCT_TEMPLATE
  ? "Due to regional restrictions, this product with PFAS cannot be shipped to "
  : "One or more items in your cart are not available for shipment to ";

const suffixMessage = IS_PRODUCT_TEMPLATE
  ? "."
  : ". Please remove them before checking out.";

const recycledmessage =
  "This product may not be deemed to be marketed as compostable in Washington or Colorado due to state regulations.";

// Global variables for persistent PFAS state management
let stateCodeCustomerLoc = null;
let stateNameCustomerLoc = null;
let countryCodeCustomerLoc = null; // customer's country code (e.g. "CA" for Canada)
let countryNameCustomerLoc = null; // customer's country name (e.g. "Canada")
let pfasRestrictionsChecked = false;
let restrictedItemStates = new Map(); // Store line -> restriction status mapping

// State-based PFAS: product restricted when the customer's state code appears in the
// restaurantware.pfas_restricted_states list (rendered into data-metafield).
function isStatePfasRestricted(itemElement) {
  const restrictedStates = itemElement && itemElement.getAttribute("data-metafield");
  return Boolean(
    restrictedStates &&
      stateCodeCustomerLoc &&
      restrictedStates.includes(stateCodeCustomerLoc)
  );
}

// Country-based PFAS: product restricted when the customer's country code appears in the
// restaurantware.sales_restricted_country list (rendered into data-country, e.g. "CA,US").
function isCountryPfasRestricted(itemElement) {
  const restrictedCountries = itemElement && itemElement.getAttribute("data-country");
  return Boolean(
    restrictedCountries &&
      countryCodeCustomerLoc &&
      restrictedCountries.includes(countryCodeCustomerLoc)
  );
}

// Combined restriction check: state-based PFAS OR country-based PFAS.
function isPfasRestricted(itemElement, stateCodeMetaField) {
  const stateRestricted = Boolean(
    stateCodeMetaField &&
      stateCodeCustomerLoc &&
      stateCodeMetaField.includes(stateCodeCustomerLoc)
  );
  return stateRestricted || isCountryPfasRestricted(itemElement);
}

// Per-item warning message. State matches reference the state and keep the
// "regional restrictions" wording; country-only matches reference the country
// ("Canada", …) and use "country restrictions" wording on the product page.
function getItemErrorMessage(itemElement) {
  const stateMatch = isStatePfasRestricted(itemElement);
  const locationName = stateMatch ? stateNameCustomerLoc : countryNameCustomerLoc;
  if (IS_PRODUCT_TEMPLATE) {
    return stateMatch
      ? `Due to regional restrictions, this product with PFAS cannot be shipped to ${locationName}.`
      : `This product cannot be shipped to ${locationName}.`;
  }
  return message + `${locationName}` + suffixMessage;
}
let errorMessage;
let recycledMarkMessage;
let stateCodeMetaField;
let recycledMetaField;
let pfasRestrictedDiv;

const GEO_API_KEY = "AIzaSyDI3RRB1e1bVKrYfAXtNAo65u29BPGIRls";


async function getGeocodingApiUrl() {
  try {
    const position = await getLocation();
    const { latitude, longitude } = position.coords;
    return `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${GEO_API_KEY}`; 
  } catch (error) {
    if (error.code === 1) {
      console.warn(
        "Geolocation is disabled. Please enable it to use this feature."
      );
    } else {
      console.error("Error getting geolocation");
    }
  }
 
}


// Function to get dynamic message based on page context and cart state.
// Pass the restricted item so country-only matches reference the country
// and use "country restrictions" wording instead of the state / "regional" wording.
function getPfasMessage(itemElement) {
  const stateMatch = isStatePfasRestricted(itemElement);
  const locationName = stateMatch ? stateNameCustomerLoc : countryNameCustomerLoc;
  if (document.body.classList.contains("template-product")) {
    return stateMatch
      ? `Due to regional restrictions, this product with PFAS cannot be shipped to ${locationName}.`
      : `This product cannot be shipped to ${locationName}.`;
  } else {
    // Check if we're in a cart context (look for cart indicators)
    const hasCartItems = document.querySelectorAll('.product-data_cart, .cart-item, .each_cart-items').length > 0;
    const isCartEmpty = document.querySelector('cart-drawer.is-empty, .cart-empty');

    if (hasCartItems && !isCartEmpty) {
      return `One or more items in your cart are not available for shipment to ${locationName}. Please remove them before checking out.`;
    } else {
      return stateMatch
        ? `Due to regional restrictions, this product with PFAS cannot be shipped to ${locationName}.`
        : `This product cannot be shipped to ${locationName}.`;
    }
  }
}

// Function to update single cart drawer warning
function updateSingleCartDrawerWarning() {
  const cartDrawerWarning = document.getElementById('pfas_restricted_cart_drawer');
  if (!cartDrawerWarning) return;
  
  // Check if any items in cart are PFAS restricted
  let hasRestrictedPfasItems = false;
  let restrictedItemElement = null;

  // Check all PFAS items for restrictions (state-based or Canada PFAS)
  const allPfasProductData = document.querySelectorAll('.product-data_cart');
  for (const itemElement of allPfasProductData) {
    const stateCodeMetaField = itemElement.getAttribute('data-metafield');

    if (isPfasRestricted(itemElement, stateCodeMetaField)) {
      hasRestrictedPfasItems = true;
      restrictedItemElement = itemElement;
      break;
    }
  }

  // Update the single warning container
  if (hasRestrictedPfasItems && (stateNameCustomerLoc || countryNameCustomerLoc)) {
    const message = getPfasMessage(restrictedItemElement);
    cartDrawerWarning.innerHTML = message;
    cartDrawerWarning.style.display = 'block';
  } else {
    cartDrawerWarning.innerHTML = '';
    cartDrawerWarning.style.display = 'none';
  }
}

// for Pfas
const cartItem = document.querySelectorAll(".product-data");
const cartItemsDrawer = document.querySelectorAll(".product-data_cart");
// for Recycled Mark
const recycledMarkCartItem = document.querySelectorAll(
  ".recycled-product-data"
);

// Listen for custom cart:updated event (dispatched after add-to-cart)
document.addEventListener('cart:updated', () => {
  // Re-run geolocation and PFAS logic after add-to-cart
  init();
  // Update single cart drawer warning
  updateSingleCartDrawerWarning();
});
function getLocation() {
  return new Promise((resolve, reject) => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(resolve, reject);
    } else {
      reject(new Error("Geolocation is not supported by this browser."));
    }
  });
}

function init() {

  // Only run geolocation check once per session
  if (!pfasRestrictionsChecked) {
    // PFAS - Get current cart items at load time
    const currentCartItems = document.querySelectorAll(".product-data");
    currentCartItems.forEach((itemElement) => {
      stateCodeMetaField = itemElement.getAttribute("data-metafield");
      const countryMetaField = itemElement.getAttribute("data-country");
      // Fetch location and check the condition when the product carries either a
      // restricted-states list or a restricted-country list (country-only items
      // have an empty data-metafield, so we must also look at data-country).
      if (stateCodeMetaField || countryMetaField) {
        reverseGeocode(itemElement, stateCodeMetaField);
      }
    });

    //Recycled Warning on Cart Page
    const recycledMetafield = document.querySelector(
      ".recycled-product-data[data-recycled-metafield]"
    );
    let recycledStateCodeMetaField;
    if (recycledMetafield) {
      recycledStateCodeMetaField = recycledMetafield.getAttribute(
        "data-recycled-metafield"
      );
      if (recycledStateCodeMetaField) {
        showRecycledWarning(
          recycledMetafield,
          recycledStateCodeMetaField
        );
      }
    }

    //Recycled on Product Detail Page
    const currentRecycledItems = document.querySelectorAll(
      ".recycled-product-data"
    );
    currentRecycledItems.forEach((itemElement) => {
      recycledMetaField = itemElement.getAttribute("data-metafield-recycled");
      if (recycledMetaField) {
        // Fetch state information and check the condition
        recycleReverseGeocode(
          itemElement,
          recycledMetaField
        );
      }
    });
  } else {
    // If already checked, just apply persistent restrictions
    applyPersistentPfasRestrictions();
  }
}

// Function to check new items that don't have stored restriction states
function checkNewItemsForRestrictions() {
  if ((!stateCodeCustomerLoc && !countryCodeCustomerLoc) || !pfasRestrictionsChecked) {
    return; // Can't check without geolocation data
  }

  const allPfasItems = document.querySelectorAll(
    '.each_cart-items[data-pfas="true"]'
  );

  allPfasItems.forEach((pfasItem) => {
    const line = pfasItem.getAttribute("data-line");

    // If this item doesn't have a stored restriction state, check it
    if (!restrictedItemStates.has(line)) {
      const pfasRestrictedDiv = document.querySelector(
        `.product-data[data-line="${line}"]`
      );
      if (pfasRestrictedDiv) {
        const stateCodeMetaField =
          pfasRestrictedDiv.getAttribute("data-metafield");
        {
          const isRestricted = isPfasRestricted(
            pfasRestrictedDiv,
            stateCodeMetaField
          );
          restrictedItemStates.set(line, isRestricted);

          if (isRestricted) {
            pfasItem.classList.add("pfas__cart-item");
            pfasItem.setAttribute("data-restricted", "true");
            if (
              !pfasRestrictedDiv.innerHTML.includes(
                "One or more items in your cart are not available for shipment to"
              )
            ) {
              pfasRestrictedDiv.innerHTML += `${getItemErrorMessage(pfasRestrictedDiv)}`;
            }
          } else {
            pfasItem.setAttribute("data-restricted", "false");
          }
        }
      }
    }
  });
}

// Function to apply persistent PFAS restrictions based on stored state
function applyPersistentPfasRestrictions() {
  // First check for any new items that need to be evaluated
  // If a PFAS item does not have a stored restriction state, check directly using stateCodeCustomerLoc
  const allPfasProductData = document.querySelectorAll('.product-data');
  allPfasProductData.forEach((itemElement) => {
    const line = itemElement.getAttribute('data-line');
    const stateCodeMetaField = itemElement.getAttribute('data-metafield');
    const hasLocation =
      (typeof stateCodeCustomerLoc === 'string' && stateCodeCustomerLoc.length > 0) ||
      (typeof countryCodeCustomerLoc === 'string' && countryCodeCustomerLoc.length > 0);
    if (!restrictedItemStates.has(line)) {
      if (hasLocation) {
        const isRestricted = isPfasRestricted(itemElement, stateCodeMetaField);
        restrictedItemStates.set(line, isRestricted);
        if (isRestricted) {
          // Remove any existing error message before adding a new one
          const errorText = getItemErrorMessage(itemElement);
          // Remove all previous error messages
          itemElement.innerHTML = itemElement.innerHTML.replace(new RegExp(errorText, 'g'), '');
          itemElement.innerHTML += `${errorText}`;
          const cartItemElement = document.querySelector(
            `[data-line="${line}"].each_cart-items`
          );
          if (
            cartItemElement &&
            cartItemElement.getAttribute("data-pfas") === "true"
          ) {
            cartItemElement.classList.add("pfas__cart-item");
            cartItemElement.setAttribute("data-restricted", "true");
          }
        }
      }
    }
  });
  checkNewItemsForRestrictions();

  // Apply restrictions to all items marked as PFAS that are in restricted states
  const allPfasItems = document.querySelectorAll(
    '.each_cart-items[data-pfas="true"]'
  );

  allPfasItems.forEach((pfasItem) => {
    const line = pfasItem.getAttribute("data-line");

    // Check if this item was previously determined to be restricted
    if (
      restrictedItemStates.has(line) &&
      restrictedItemStates.get(line) === true
    ) {
      // Mark as restricted
      pfasItem.classList.add("pfas__cart-item");
      pfasItem.setAttribute("data-restricted", "true");

      // Apply error message if not already present
      const pfasRestrictedDiv = document.querySelector(
        `.product-data[data-line="${line}"]`
      );
      if (
        pfasRestrictedDiv &&
        !pfasRestrictedDiv.innerHTML.includes(
          "One or more items in your cart are not available for shipment to"
        )
      ) {
        pfasRestrictedDiv.innerHTML += `${getItemErrorMessage(pfasRestrictedDiv)}`;
      }
    } else if (
      restrictedItemStates.has(line) &&
      restrictedItemStates.get(line) === false
    ) {
      // Explicitly mark as not restricted
      pfasItem.classList.remove("pfas__cart-item");
      pfasItem.setAttribute("data-restricted", "false");
    }
  });

  // Apply to warning containers
  const pfasWarningDivs = document.querySelectorAll(".pfas-warning-container");
  pfasWarningDivs.forEach((warningDiv) => {
    const pfasStates = warningDiv.getAttribute("data-pfas-states");
    if (
      (pfasStates &&
        stateCodeCustomerLoc &&
        pfasStates.includes(stateCodeCustomerLoc)) ||
      isCountryPfasRestricted(warningDiv)
    ) {
      warningDiv.classList.add("pfas__cart-item");
    }
  });

  // Update single cart drawer warning
  updateSingleCartDrawerWarning();
}

// Pfas
async function reverseGeocode( itemElement, stateCodeMetaField) {
  const geocodingApiUrl = await getGeocodingApiUrl();
  fetch(geocodingApiUrl)
    .then((response) => response.json())
    .then((data) => {
      const addressComponents = data.results[0].address_components;
      // Find the state in the address components
      const state = addressComponents.find((component) =>
        component.types.includes("administrative_area_level_1")
      );
      // Find the country in the address components (Canada PFAS check)
      const country = addressComponents.find((component) =>
        component.types.includes("country")
      );
      stateCodeCustomerLoc = state ? state.short_name : null; // state code from customer's location
      stateNameCustomerLoc = state ? state.long_name : null; // state name for dynamic messages
      countryCodeCustomerLoc = country ? country.short_name : null; // country code (e.g. "CA")
      countryNameCustomerLoc = country ? country.long_name : null; // country name (e.g. "Canada")
      errorMessage = message + `${stateNameCustomerLoc}` + suffixMessage;

      const line = itemElement.getAttribute("data-line");
      const isRestricted = isPfasRestricted(itemElement, stateCodeMetaField);

      // Store the restriction state for this item persistently
      restrictedItemStates.set(line, isRestricted);

      if (isRestricted) {
        // Guard against a duplicate append if the geocode resolves more than once
        const itemErrorMessage = getItemErrorMessage(itemElement);
        if (!itemElement.innerHTML.includes(itemErrorMessage)) {
          itemElement.innerHTML += `${itemErrorMessage}`;
        }

        // Add pfas__cart-item class to the cart item if both PFAS and restricted
        const cartItemElement = document.querySelector(
          `[data-line="${line}"].each_cart-items`
        );
        if (
          cartItemElement &&
          cartItemElement.getAttribute("data-pfas") === "true"
        ) {
          cartItemElement.classList.add("pfas__cart-item");
          cartItemElement.setAttribute("data-restricted", "true");
        }

        // Add pfas__cart-item class to warning div if both PFAS and restricted
        const pfasWarningSelector = isStatePfasRestricted(itemElement)
          ? `.pfas-warning-container[data-pfas-states*="${stateCodeCustomerLoc}"]`
          : `.pfas-warning-container[data-country*="${countryCodeCustomerLoc}"]`;
        const pfasWarningDiv = document.querySelector(pfasWarningSelector);
        if (pfasWarningDiv) {
          pfasWarningDiv.classList.add("pfas__cart-item");
        }

        // Dispatch a custom event with the message
        document.dispatchEvent(
          new CustomEvent("pfasWarning", { detail: { errorMessage } })
        );
      }

      // Update single cart drawer warning
      updateSingleCartDrawerWarning();

      // Mark that PFAS restrictions have been checked
      pfasRestrictionsChecked = true;
    })
    .catch((error) => {
      console.error("error", error);
    });
}
// Recycled Mark
async function recycleReverseGeocode(
  itemElement,
  recycledMetaField
) {
 const geocodingApiUrl = await getGeocodingApiUrl();
  fetch(geocodingApiUrl)
    .then((response) => response.json())
    .then((data) => {
      const addressComponents = data.results[0].address_components;
      // Find the state in the address components
      const state = addressComponents.find((component) =>
        component.types.includes("administrative_area_level_1")
      );
      stateCodeCustomerLoc = state.short_name; // getting state code from customer's location state
      recycledMarkMessage = recycledmessage;
      if (recycledMetaField.includes(stateCodeCustomerLoc)) {
        itemElement.innerHTML += `${recycledMarkMessage}`;
        // Dispatch a custom event with the message
        document.dispatchEvent(
          new CustomEvent("pfasWarning", { detail: { errorMessage } })
        );
      }
    })
    .catch((error) => {
      console.error("error", error);
    });
}
init();
// Pfas error message based on geolocation code end

async function showRecycledWarning(
  recycledMetafield,
  recycledStateCodeMetaField
) {
  const geocodingApiUrl = await getGeocodingApiUrl();
  fetch(geocodingApiUrl)
    .then((response) => response.json())
    .then((data) => {
      const addressComponents = data.results[0].address_components;
      // Find the state in the address components
      const state = addressComponents.find((component) =>
        component.types.includes("administrative_area_level_1")
      );
      stateCodeCustomerLoc = state.short_name; // getting state code from customer's location state

      // const recycledMetafield = document.querySelector('.recycled-product-data[data-recycled-metafield]');
      // let recycledStateCodeMetaField;
      // if (recycledMetafield) {
      //   recycledStateCodeMetaField = recycledMetafield.getAttribute('data-recycled-metafield');

      // }
      warningMessage =
        "One or more product may not be deemed to be marketed as compostable in Washington or Colorado due to state regulations.";
      if (recycledStateCodeMetaField.includes(stateCodeCustomerLoc)) {
        recycledMetafield.innerHTML += `${warningMessage}`;
      }
    })
    .catch((error) => {
      console.error("error", error);
    });
}

class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", (event) => {
      event.preventDefault();
      const cartItems =
        this.closest("cart-items") || this.closest("cart-drawer-items");
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define("cart-remove-button", CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById("shopping-cart-line-item-status") ||
      document.getElementById("CartDrawer-LineItemStatus");

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener("change", debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.cartUpdate,
      (event) => {
        if (event.source === "cart-items") {
          return;
        }
        this.onCartUpdate();
      }
    );
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute("name")
    );
  }

  onCartUpdate() {
    fetch(`${routes.cart_url}?section_id=main-cart-items`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const sourceQty = html.querySelector("cart-items");
        this.innerHTML = sourceQty.innerHTML;

        // Clean up restrictedItemStates for removed items
        const currentItems = new Set();
        document
          .querySelectorAll(".each_cart-items[data-line]")
          .forEach((item) => {
            currentItems.add(item.getAttribute("data-line"));
          });

        // Remove restriction states for items no longer in cart
        for (const [line, isRestricted] of restrictedItemStates.entries()) {
          if (!currentItems.has(line)) {
            restrictedItemStates.delete(line);
          }
        }

        // Apply persistent PFAS restrictions after cart update
        if (pfasRestrictionsChecked && stateCodeCustomerLoc) {
          applyPersistentPfasRestrictions();
        }
        
        // Update single cart drawer warning
        updateSingleCartDrawerWarning();
        
        // Re-run geolocation and PFAS logic after cart update
        // This ensures showPosition(position) is called for new items
        init();
      })
      .catch((e) => {
        console.error(e);
      });
  }

  getSectionsToRender() {
    return [
      {
        id: "main-cart-items",
        section: document.getElementById("main-cart-items").dataset.id,
        selector: ".js-contents",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
      {
        id: "cart-live-region-text",
        section: "cart-live-region-text",
        selector: ".shopify-section",
      },
      {
        id: "main-cart-footer",
        section: document.getElementById("main-cart-footer").dataset.id,
        selector: ".js-contents",
      },
    ];
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);
    this.querySelectorAll(".quantity__button").forEach((button) =>
      button.classList.add("disabled")
    );

    if (
      document.querySelectorAll(
        '.card--product card__add-to-cart button[name="add"]'
      )
    ) {
      document
        .querySelectorAll(
          '.card--product .card__add-to-cart button[name="add"]'
        )
        .forEach((button) => {
          button.setAttribute("aria-disabled", false);
          button.querySelector("span").classList.remove("hidden");
          button.querySelector(".sold-out-message").classList.add("hidden");
        });
    }

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) ||
          document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll(".cart-item");
        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute("value");
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle("is-empty", parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector("cart-drawer");
        const cartFooter = document.getElementById("main-cart-footer");

        if (cartFooter)
          cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);
        if (cartDrawerWrapper)
          cartDrawerWrapper.classList.toggle(
            "is-empty",
            parsedState.item_count === 0
          );

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document
              .getElementById(section.id)
              .querySelector(section.selector) ||
            document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        const updatedValue = parsedState.items[line - 1]
          ? parsedState.items[line - 1].quantity
          : undefined;
        let message = "";
        if (
          items.length === parsedState.items.length &&
          updatedValue !== parseInt(quantityElement.value)
        ) {
          if (typeof updatedValue === "undefined") {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace(
              "[quantity]",
              updatedValue
            );
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) ||
          document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(
                cartDrawerWrapper,
                lineItem.querySelector(`[name="${name}"]`)
              )
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(
            cartDrawerWrapper.querySelector(".drawer__inner-empty"),
            cartDrawerWrapper.querySelector("a")
          );
        } else if (document.querySelector(".cart-item") && cartDrawerWrapper) {
          trapFocus(
            cartDrawerWrapper,
            document.querySelector(".cart-item__name")
          );
        }
        publish(PUB_SUB_EVENTS.cartUpdate, { source: "cart-items" });
      })
      .catch(() => {
        this.querySelectorAll(".loading-overlay").forEach((overlay) =>
          overlay.classList.add("hidden")
        );
        this.querySelectorAll(".quantity__button").forEach((button) =>
          button.classList.remove("disabled")
        );
        const errors =
          document.getElementById("cart-errors") ||
          document.getElementById("CartDrawer-CartErrors");
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.querySelectorAll(".quantity__button").forEach((button) =>
          button.classList.remove("disabled")
        );
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) ||
      document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError)
      lineItemError.querySelector(".cart-item__error-text").innerHTML = message;

    this.lineItemStatusElement.setAttribute("aria-hidden", true);

    const cartStatus =
      document.getElementById("cart-live-region-text") ||
      document.getElementById("CartDrawer-LiveRegionText");
    cartStatus.setAttribute("aria-hidden", false);

    setTimeout(() => {
      cartStatus.setAttribute("aria-hidden", true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.add("cart__items--disabled");

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading-overlay`
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading-overlay`
    );

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) =>
      overlay.classList.remove("hidden")
    );

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute("aria-hidden", false);
  }

  disableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.remove("cart__items--disabled");

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading-overlay`
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading-overlay`
    );

    cartItemElements.forEach((overlay) => overlay.classList.add("hidden"));
    cartDrawerItemElements.forEach((overlay) =>
      overlay.classList.add("hidden")
    );

    // Apply persistent PFAS restrictions after loading completes
    if (pfasRestrictionsChecked && stateCodeCustomerLoc) {
      applyPersistentPfasRestrictions();
    }
    
    // Update single cart drawer warning
    updateSingleCartDrawerWarning();

    // pfas cart drawer code on load (for backward compatibility)---------------------------------------
    const currentCartItemsDrawer =
      document.querySelectorAll(".product-data_cart");
    currentCartItemsDrawer.forEach((itemElement) => {
      const line = itemElement.getAttribute("data-line");
      pfasRestrictedDiv = document.getElementById(
        `pfas_restricted_cart-${line}`
      );
      const stateCodeMetaField = itemElement.getAttribute("data-metafield");

      // Check persistent state first
      const itemErrorMessage = getItemErrorMessage(itemElement);
      if (restrictedItemStates.has(line) && restrictedItemStates.get(line)) {
        if (pfasRestrictedDiv && pfasRestrictedDiv.innerHTML != itemErrorMessage) {
          pfasRestrictedDiv.innerHTML += `${itemErrorMessage}`;
        }
      } else if (isPfasRestricted(itemElement, stateCodeMetaField)) {
        if (pfasRestrictedDiv && pfasRestrictedDiv.innerHTML != itemErrorMessage) {
          pfasRestrictedDiv.innerHTML += `${itemErrorMessage}`;
        }
      }
    });

    // pfas cart and product page code on load (for backward compatibility)-----------------------------
    const currentCartItem = document.querySelectorAll(".product-data");
    currentCartItem.forEach((itemElement) => {
      const line = itemElement.getAttribute("data-line");
      pfasRestrictedDiv = document.getElementById(`pfas_restricted-${line}`);
      const stateCodeMetaField = itemElement.getAttribute("data-metafield");

      // Check persistent state first
      const itemErrorMessage = getItemErrorMessage(itemElement);
      if (restrictedItemStates.has(line) && restrictedItemStates.get(line)) {
        if (pfasRestrictedDiv) {
          pfasRestrictedDiv.innerHTML = `${itemErrorMessage}`;
        }

        // Add data-restricted attribute to the cart item
        const cartItemElement = document.querySelector(
          `[data-line="${line}"].each_cart-items[data-pfas="true"]`
        );
        if (cartItemElement) {
          cartItemElement.classList.add("pfas__cart-item");
          cartItemElement.setAttribute("data-restricted", "true");
        }
      } else if (isPfasRestricted(itemElement, stateCodeMetaField)) {
        if (pfasRestrictedDiv) {
          pfasRestrictedDiv.innerHTML = `${itemErrorMessage}`;
        }

        // Add data-restricted attribute to the cart item
        const cartItemElement = document.querySelector(
          `[data-line="${line}"].each_cart-items[data-pfas="true"]`
        );
        if (cartItemElement) {
          cartItemElement.classList.add("pfas__cart-item");
          cartItemElement.setAttribute("data-restricted", "true");
        }
      }
    });
    // --------------------------------------------------
  }
}

customElements.define("cart-items", CartItems);

if (!customElements.get("cart-note")) {
  customElements.define(
    "cart-note",
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          "change",
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, {
              ...fetchConfig(),
              ...{ body },
            });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}
